<div
  class="max-w-full mx-auto flex items-center justify-between p-8 transition-width"
  [ngClass]="{
    'w-full': fullWidthNav,
    'bg-theme-gray-twentyone md:bg-transparent': buttonsState !== 'close'
  }"
  id="navbarContainer"
>
  <div class="navbar-header">
    <a class="navbar-brand" routerLink="/" title="Homepage">
      <app-site-logo></app-site-logo>
    </a>
  </div>

  <div class="navbar-scrolltop" (click)="scrollToTop()"></div>

  <ng-container *ngIf="!isApplicationService.isApplication()">
    <div class="navbar-hamburger" (click)="toggleButtonsState()">
      <svg-icon
        src="assets/images/svg-icons/icon-burger.svg"
        [svgStyle]="{ 'width.px': '24' }"
        *ngIf="buttonsState === 'close'"
      ></svg-icon>
      <svg-icon
        src="assets/images/svg-icons/icon-times.svg"
        [svgStyle]="{ 'width.px': '14' }"
        *ngIf="buttonsState !== 'close'"
      ></svg-icon>
    </div>

    <div
      class="navbar-collapse absolute md:static right-0 left-0 md:pt-0 h-0 md:h-auto overflow-hidden"
      [class.h-auto]="buttonsState !== 'close'"
    >
      <ul
        class="flex flex-col md:flex-row items-center bg-theme-gray-twentyone md:bg-transparent p-4 md:p-0"
      >
        <li class="nav-link">
          <a
            matRipple
            [matRippleCentered]="false"
            [matRippleUnbounded]="true"
            [matRippleRadius]="50"
            (click)="scrollToLanding('sectionSavoir')"
            >{{ 'navbar.main.savoir_plus' | translate }}</a
          >
        </li>

        <li class="nav-link" *ngIf="languageService.linkToPremiumInPublicTopNav">
          <a
            matRipple
            [matRippleCentered]="false"
            [matRippleUnbounded]="true"
            [matRippleRadius]="50"
            [routerLink]="['/pricing']"
            >{{ 'landing.abonnement' | translate }}</a
          >
        </li>

        <li class="nav-link" *ngIf="languageService.testimoniesEnabled">
          <a
            matRipple
            [matRippleCentered]="false"
            [matRippleUnbounded]="true"
            [matRippleRadius]="50"
            [routerLink]="['/testimonies']"
            >{{ 'livreor.temoignages' | translate : { siteName: languageService.siteName } }}</a
          >
        </li>
        <li class="nav-connect">
          <a
            matRipple
            [matRippleCentered]="false"
            [matRippleUnbounded]="true"
            [matRippleRadius]="50"
            [routerLink]="['/user/login']"
            (click)="buttonsState = 'close'"
            class="btn-nnki btn-nnki-transparent-with-border"
            >{{ 'navbar.main.se_connecter' | translate }}</a
          >
        </li>
        <li class="nav-connect">
          <a
            matRipple
            [matRippleCentered]="false"
            [matRippleUnbounded]="true"
            [matRippleRadius]="50"
            [routerLink]="['/user/register']"
            (click)="buttonsState = 'close'"
            class="btn-nnki btn-nnki-primary"
            >{{ 'navbar.main.essai' | translate }}</a
          >
        </li>
      </ul>
    </div>
  </ng-container>
</div>
